// extracted by mini-css-extract-plugin
var _1 = "s8vymhBtVvIWlnKEpXFw";
export { _1 as "archived" }
